import { render, staticRenderFns } from "./tabMaterialsStockProduct.vue?vue&type=template&id=0bc00002&scoped=true&"
import script from "./tabMaterialsStockProduct.vue?vue&type=script&lang=js&"
export * from "./tabMaterialsStockProduct.vue?vue&type=script&lang=js&"
import style0 from "./tabMaterialsStockProduct.vue?vue&type=style&index=0&lang=css&"
import style1 from "./tabMaterialsStockProduct.vue?vue&type=style&index=1&id=0bc00002&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bc00002",
  null
  
)

export default component.exports